import * as React from "react";
import { Checkbox, ListGroupItem } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import * as url from "url";
import { ComponentEx } from "../../../controls/ComponentEx";
import { Icon } from "../../../controls/api";
import * as selectors from "../../../util/selectors";
import { getSafe } from "../../../util/storeHelper";
import { setLoadOrderEntry } from "../actions/loadOrder";
class DefaultItemRenderer extends ComponentEx {
    constructor(props) {
        super(props);
        this.initState({});
    }
    render() {
        const item = this.props.item;
        return !!item.locked ? this.renderLocked(item) : this.renderDraggable(item);
    }
    renderModImg() {
        const { itemRendererOptions, item } = this.props;
        let effectiveURL;
        try {
            const parsedUrl = new URL(item.imgUrl);
            effectiveURL = item.imgUrl; // If URL parsing succeeds, it already has a protocol
        }
        catch (err) {
            // If URL parsing fails, it's likely a file path, convert to file URL
            try {
                effectiveURL = url.pathToFileURL(item.imgUrl).href;
            }
            catch (pathErr) {
                return null;
            }
        }
        return itemRendererOptions.listViewType !== "compact" ? (React.createElement("img", { src: effectiveURL, id: "mod-img" })) : null;
    }
    renderExternalBanner() {
        const { t } = this.props;
        return (React.createElement("div", { className: "load-order-unmanaged-banner" },
            React.createElement("span", null, t("Not managed by Vortex")),
            React.createElement(Icon, { className: "external-caution-logo", name: "feedback-warning" })));
    }
    renderLocked(item) {
        const { loadOrder, className } = this.props;
        const position = item.prefix !== undefined ? item.prefix : loadOrder[item.id].pos + 1;
        const key = `${item.name}-${position}`;
        let classes = ["load-order-entry"];
        if (className !== undefined) {
            classes = classes.concat(className.split(" "));
        }
        return (React.createElement(ListGroupItem, { key: key, className: classes.join(" "), onContextMenu: this.props.onContextMenu },
            React.createElement("p", { className: "load-order-index" }, position),
            this.renderModImg(),
            React.createElement("div", null,
                React.createElement("p", null, item.name),
                item.external === true && this.renderExternalBanner()),
            React.createElement(Icon, { className: "locked-entry-logo", name: "locked" })));
    }
    renderDraggable(item) {
        const { loadOrder, className, itemRendererOptions } = this.props;
        const position = item.prefix !== undefined ? item.prefix : loadOrder[item.id].pos + 1;
        const key = `${item.name}-${position}`;
        let classes = ["load-order-entry"];
        if (className !== undefined) {
            classes = classes.concat(className.split(" "));
        }
        const checkBox = () => !!itemRendererOptions?.displayCheckboxes ? (React.createElement(Checkbox, { className: "entry-checkbox", checked: loadOrder[item.id].enabled, disabled: item.locked, onChange: this.onStatusChange })) : null;
        return (React.createElement(ListGroupItem, { ref: this.setRef, key: key, className: classes.join(" "), onContextMenu: this.props.onContextMenu },
            React.createElement(Icon, { className: "drag-handle-icon", name: "drag-handle" }),
            React.createElement("p", { className: "load-order-index" }, position),
            React.createElement("div", null,
                !!item?.external && this.renderExternalBanner(),
                this.renderModImg()),
            React.createElement("p", null, item.name),
            checkBox()));
    }
    onStatusChange = (evt) => {
        const { loadOrder, item, onSetLoadOrderEntry, profile } = this.props;
        const entry = {
            pos: loadOrder[item.id].pos,
            enabled: evt.target.checked,
        };
        onSetLoadOrderEntry(profile.id, item.id, entry);
    };
    setRef = (ref) => {
        return this.props.onRef(ref);
    };
}
const empty = {};
const defaultRendererOpts = {
    listViewType: "full",
    displayCheckboxes: true,
};
function mapStateToProps(state, ownProps) {
    const profile = selectors.activeProfile(state);
    return {
        profile,
        loadOrder: getSafe(state, ["persistent", "loadOrder", profile.id], empty),
        modState: getSafe(profile, ["modState"], empty),
        itemRendererOptions: getSafe(state, ["settings", "loadOrder", "rendererOptions", profile.gameId], defaultRendererOpts),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetLoadOrderEntry: (profileId, modId, entry) => dispatch(setLoadOrderEntry(profileId, modId, entry)),
    };
}
export default withTranslation(["common"])(connect(mapStateToProps, mapDispatchToProps)(DefaultItemRenderer));
